import { INTERVIEW } from '../constants';

export default {
  isValidTypeOfAudioFile: (type) => INTERVIEW.files.audio.types.includes(type.replace(/\/.*/, '/*')),
  isTypeOfTXT: (filename = '') => filename.endsWith('.txt'),
  isValidFormatOfTranscriptFile: (filename) => INTERVIEW.files.transcript.types.includes(`.${filename?.split('.').reverse()[0]}`),
};
